// React for Website

import React from "react";
//outsource
import { Col, Form, Input } from "antd";
import { HiOutlineMail } from "react-icons/hi";

//components

const VoucherEmail = () => {
  // -------------------------- VAR --------------------------
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------

  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  return (
    <Form.Item
      name="email"
      label="Receiver Email"
      rules={[
        {
          required: true,
          message: "Please input the email",
        },
        {
          whitespace: true,
          message: "Invalid email address",
        },
        {
          type: "email",
          message: "Invalid email address",
        },
      ]}
    >
      <Input
        addonBefore={<HiOutlineMail />}
        placeholder="Please input Email Address"
      />
    </Form.Item>
  );
};

export default VoucherEmail;
